import { render, staticRenderFns } from "./GroupTags.vue?vue&type=template&id=60d3ff70&scoped=true"
import script from "./GroupTags.vue?vue&type=script&lang=js"
export * from "./GroupTags.vue?vue&type=script&lang=js"
import style0 from "./GroupTags.vue?vue&type=style&index=0&id=60d3ff70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3ff70",
  null
  
)

export default component.exports